// @flow

export type Tenant = {
  code: TenantCode,
};

export type TenantCode =
  | 'CROSS_BORDER'
  | 'LOCAL_LATAM'
  | 'DIAMOND'
  | 'FRONTIER'
  ;

export const CROSS_BORDER: Tenant = {
  code: 'CROSS_BORDER',
};

export const LOCAL_LATAM: Tenant = {
  code: 'LOCAL_LATAM',
};

export const DIAMOND: Tenant = {
  code: 'DIAMOND',
};

export const FRONTIER: Tenant = {
  code: 'FRONTIER',
};

export function getTenantFromCode(tenantCode: string): Tenant {
  const tenant = SUPPORTED_TENANTS.find((tenant: Tenant) => {
    return tenant.code == tenantCode;
  });

  if (!tenant) {
    throw new Error(`Tenant "${tenantCode}" is not supported`);
  }

  return tenant;
}

export const SUPPORTED_TENANTS: ImmutableArray<Tenant> = [
  CROSS_BORDER,
  LOCAL_LATAM,
  DIAMOND,
  FRONTIER,
];

export function isLocalLatamTenantCode(tenantCode?: string): boolean {
  return tenantCode === LOCAL_LATAM.code;
}

export function isDiamondTenantCode(tenantCode?: string): boolean {
  return tenantCode === DIAMOND.code;
}

export function isFrontierTenantCode(tenantCode?: string): boolean {
  return tenantCode === FRONTIER.code;
}

export function getApiBaseUrlByTenant(tenant: Tenant): string {
  return getApiBaseUrlByTenantCode(tenant.code);
}

export function getApiBaseUrlByTenantCode(tenantCode: TenantCode): string {
  return ENV_CONSTANTS.EBANX_API_BASE_URLS_PER_TENANT[tenantCode];
}

export function resolveTenantTitle(localTenancy?: string): string {
  return 'EBANX';
}
